export default {"src":"/_next/static/media/soical-reach.a81b4d27.svg","height":75,"width":76,"blurWidth":0,"blurHeight":0};